



























import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'BlkBadge'
})
export default class extends Vue {
  @Prop(String) iconName!: string
  @Prop({ default: '', type: String }) text!: string
  @Prop({ default: false, type: Boolean }) small!: Boolean
}
